import React from "react";
import Link from "next/link";
import Image from "next/image";
import classNames from "classnames";

import { applicationRoutes } from "shared/helpers/applicationRouting";
import Typography from "shared/components/Typography";
import { PodcastInterface } from "shared/helpers/pageHelpers/Podcast/interface";
import FollowPodcastButton from "@/components/FollowPodcastButton";
import { getImgixURL } from "@/helpers/getImgixURL";

import styles from "./PodcastCard.module.scss";

export const PodcastCard: React.FC<PodcastInterface> = ({
  layout = "full",
  className,
  slug,
  title,
  picture,
  hosts,
  size,
  followed,
  index,
}) => {
  const displayedHosts = hosts.slice(0, 2);
  const additionaldHosts = hosts.slice(2).length;

  const img = getImgixURL(picture);

  return (
    <div
      className={classNames(
        styles.card,
        styles[size],
        styles[layout],
        className
      )}
    >
      <Link
        href={`${applicationRoutes.PODCAST}[slug]`}
        as={applicationRoutes.PODCAST + slug}
      >
        <div className={styles.artwork}>
          <Image
            src={img}
            alt={title}
            layout="fill"
            objectFit="cover"
            placeholder="blur"
            blurDataURL={`https://newonce.imgix.net/${img}?fm=blurhash`}
            priority={index < 3}
          />
        </div>
      </Link>

      <div className={styles.meta}>
        <div className={styles.authors}>
          {displayedHosts.map(({ slug, name, id }) => (
            <Link
              href={{
                pathname: `${applicationRoutes.AUTHOR}[slug]`,
                query: { from: "Podcasty" },
              }}
              as={applicationRoutes.AUTHOR + slug}
              key={id}
            >
              <a className={styles.link}>
                <Typography variant="medium">{name}</Typography>
              </a>
            </Link>
          ))}
          {additionaldHosts > 0 && (
            <Link
              href={`${applicationRoutes.PODCAST}[slug]`}
              as={applicationRoutes.PODCAST + slug}
            >
              <a className={classNames(styles.link, styles["more-hosts"])}>
                <Typography variant="medium">
                  +{additionaldHosts} więcej
                </Typography>
              </a>
            </Link>
          )}
        </div>

        <Link
          href={`${applicationRoutes.PODCAST}[slug]`}
          as={applicationRoutes.PODCAST + slug}
        >
          <a className={styles.titleLink}>
            <Typography variant="h5" component="h3">
              {title}
            </Typography>
          </a>
        </Link>
      </div>

      <FollowPodcastButton
        size="small"
        variant="round"
        slug={slug}
        followed={followed}
        className={styles.follow}
      />
    </div>
  );
};

export default PodcastCard;
